<div class="ce-page">

    <!-- Fejléc -->
    <div class="ce-head">
        <div class="ce-head__copy">
            <h1 class="stk-page-title">
                <span *ngIf="!isProduct">{{ componentId === 0 ? 'Új komponens' : 'Komponens szerkesztése' }}</span>
                <span *ngIf="isProduct">{{ componentId === 0 ? 'Új termék' : 'Termék szerkesztése' }}</span>
            </h1>
            <div class="stk-page-sub" *ngIf="fetchedComponent">{{ fetchedComponent.name }} · {{ fetchedComponent.sku }}</div>
            <div class="stk-page-sub" *ngIf="!fetchedComponent">Törzsadatok, gyártási paraméterek és összetevők egy helyen.</div>
        </div>
        <button type="button" class="ce-back-btn" [routerLink]="isProduct ? '/inventory' : '/components'">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="15,5 8,12 15,19"></polyline></svg>
            {{ isProduct ? 'Vissza a készlethez' : 'Vissza a komponens listához' }}
        </button>
    </div>

    <form [formGroup]="componentForm" (ngSubmit)="saveComponent()" class="ce-form" [class.ce-form--with-bom]="componentForm.get('has_bom')?.value">

        <div class="ce-col">

            <!-- Alapadatok -->
            <div class="ce-card">
                <div class="ce-card__kicker">Alapadatok</div>

                <div class="ce-photo-row">
                    <label class="ce-photo" title="Kép kiválasztása">
                        <input type="file" (change)="onFileSelected($event)" accept="image/*">
                        <img *ngIf="imageUrl" [src]="imageUrl" alt="Komponens fotó">
                        <span *ngIf="!imageUrl">fotó<br>csere</span>
                    </label>
                    <div class="ce-photo-fields">
                        <div class="ce-field">
                            <div class="ce-label">Név</div>
                            <input class="ce-input" type="text" formControlName="name">
                            <div class="ce-error" *ngIf="componentForm.get('name')?.touched && componentForm.get('name')?.invalid">Mező kitöltése kötelező</div>
                        </div>
                        <div class="ce-field">
                            <div class="ce-label">SKU</div>
                            <input class="ce-input ce-input--muted" type="text" formControlName="sku" placeholder="mentéskor generálódik">
                        </div>
                    </div>
                </div>
                <button type="button" class="ce-photo-remove" *ngIf="imageToUpload" (click)="removePhoto()">Új kép elvetése</button>

                <!-- Típus — a design háromféle típusa (gombsor) -->
                <div class="ce-field">
                    <div class="ce-label">Típus</div>
                    <div class="ce-type-chips">
                        <button
                            type="button"
                            class="ce-type-chip"
                            *ngFor="let t of ctypeOptions"
                            [class.is-active]="ctype === t.key"
                            (click)="setType(t.key)"
                        >{{ t.label }}</button>
                    </div>
                </div>

                <div class="ce-grid2">
                    <div class="ce-field">
                        <div class="ce-label">Játék</div>
                        <app-bgf-auto-selector instanceType="game" formControlName="game"></app-bgf-auto-selector>
                        <div class="ce-error" *ngIf="componentForm.get('game')?.touched && componentForm.get('game')?.invalid">Mező kitöltése kötelező</div>
                    </div>
                    <div class="ce-field" *ngIf="componentForm.get('for_sale')?.value">
                        <div class="ce-label">Termék csoport</div>
                        <app-bgf-auto-selector instanceType="product-group" formControlName="product_group"></app-bgf-auto-selector>
                    </div>
                </div>

                <div class="ce-toggles">
                    <div class="ce-toggle" [class.ce-toggle--disabled]="componentForm.get('for_sale')?.disabled" (click)="toggleFlag('for_sale')">
                        <div class="ce-toggle__box" [class.ce-toggle__box--on]="flagOn('for_sale')">
                            <svg *ngIf="flagOn('for_sale')" width="12" height="12" viewBox="0 0 14 14"><polyline points="2,7.5 5.5,11 12,3.5" fill="none" stroke="#FFFFFF" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"></polyline></svg>
                        </div>
                        <div class="ce-toggle__copy">
                            <div class="ce-toggle__title">Értékesített</div>
                            <div class="ce-toggle__sub">Termékként is eladható — megjelenik a Készlet nézetben.</div>
                        </div>
                    </div>
                    <div class="ce-toggle" (click)="toggleFlag('is_custom')">
                        <div class="ce-toggle__box" [class.ce-toggle__box--on]="flagOn('is_custom')">
                            <svg *ngIf="flagOn('is_custom')" width="12" height="12" viewBox="0 0 14 14"><polyline points="2,7.5 5.5,11 12,3.5" fill="none" stroke="#FFFFFF" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"></polyline></svg>
                        </div>
                        <div class="ce-toggle__copy">
                            <div class="ce-toggle__title">Egyedi (custom) rendelés komponense</div>
                            <div class="ce-toggle__sub">Rendelésre gyártjuk (pl. Etsy personalizáció) — nem tartunk belőle állandó készletet.</div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Gyártási adatok -->
            <div class="ce-card">
                <div class="ce-card__kicker">Gyártási adatok</div>
                <div class="ce-field" *ngIf="ctype === 'printed'">
                    <div class="ce-label">Anyag</div>
                    <app-bgf-auto-selector instanceType="material" formControlName="material"></app-bgf-auto-selector>
                </div>
                <div class="ce-grid2">
                    <div class="ce-field">
                        <div class="ce-label">Súly (g)</div>
                        <input class="ce-input ce-input--num" type="number" step=".01" min="0" formControlName="weight">
                        <div class="ce-error" *ngIf="componentForm.get('weight')?.touched && componentForm.get('weight')?.invalid">A súly nem lehet negatív</div>
                    </div>
                    <div class="ce-field" *ngIf="ctype === 'printed'">
                        <div class="ce-label">Nyomt. idő (perc)</div>
                        <input class="ce-input ce-input--num" type="number" min="0" formControlName="printing_time">
                        <div class="ce-error" *ngIf="componentForm.get('printing_time')?.touched && componentForm.get('printing_time')?.invalid">A nyomtatási idő nem lehet negatív</div>
                    </div>
                    <div class="ce-field" *ngIf="ctype === 'bought'">
                        <div class="ce-label">Beszerzési ár (Ft/db)</div>
                        <input class="ce-input ce-input--num" type="number" step="0.01" min="0" formControlName="purchase_price">
                        <div class="ce-error" *ngIf="componentForm.get('purchase_price')?.touched && componentForm.get('purchase_price')?.invalid">A beszerzési ár nem lehet negatív</div>
                    </div>
                </div>
            </div>

            <!-- Vám — a UPS vámáru-számlájára (Commercial Invoice) kerül -->
            <div class="ce-card" *ngIf="isProduct || flagOn('for_sale')">
                <div class="ce-card__kicker">Szállítás / vám</div>
                <div class="ce-grid2">
                    <div class="ce-field">
                        <div class="ce-label">HS kód</div>
                        <input class="ce-input" formControlName="hs_code" placeholder="9503000090" inputmode="numeric">
                        <div class="ce-error" *ngIf="componentForm.get('hs_code')?.touched && componentForm.get('hs_code')?.invalid">6–10 számjegy</div>
                    </div>
                    <div class="ce-field">
                        <div class="ce-label">Vámleírás (angol)</div>
                        <input class="ce-input" formControlName="customs_description" maxlength="120" placeholder="pl. Plastic board game parts">
                    </div>
                </div>
            </div>

            <!-- Készlet -->
            <div class="ce-card">
                <div class="ce-card__kicker">Készlet</div>
                <div class="ce-field ce-field--limit" *ngIf="!flagOn('is_custom')">
                    <div class="ce-label">Minimum készlet — kézi érték</div>
                    <input class="ce-input ce-input--num ce-input--limit" type="number" min="0" formControlName="limit">
                    <div class="ce-error" *ngIf="componentForm.get('limit')?.touched && componentForm.get('limit')?.invalid">A minimum készlet nem lehet negatív</div>

                    <!-- A kettő közül melyik van most érvényben. Enélkül a
                         felhasználó átírja a kézi értéket, és nem érti, miért
                         nem változik semmi. -->
                    <div class="ce-limit-info" *ngIf="componentId > 0">
                        <div class="ce-limit-info__row">
                            <span class="ce-limit-info__k">Automatikusan számolt</span>
                            <span class="ce-limit-info__v">{{ autoLimit === null ? 'nincs elég adat' : autoLimit + ' db' }}</span>
                        </div>
                        <div class="ce-limit-info__row">
                            <span class="ce-limit-info__k">Jelenleg mérvadó</span>
                            <span class="ce-limit-info__v ce-limit-info__v--strong">
                                {{ effectiveLimit }} db · {{ limitSource === 'auto' ? 'automatikus' : 'kézi' }}
                            </span>
                        </div>
                        <div class="ce-limit-info__note" *ngIf="limitSource === 'auto'">
                            A raktárszabály számolt szintje van érvényben. A kézi érték megmarad, és a
                            szabály kikapcsolásakor (vagy elégtelen eladási adat esetén) azonnal visszaáll.
                        </div>
                        <div class="ce-limit-info__note" *ngIf="limitSource === 'manual'">
                            A kézi érték a mérvadó — 30 napnál rövidebb eladási előzménynél mindig ez.
                        </div>
                    </div>
                </div>

                <!-- Feladási szabály alóli kivétel: csak nem eladható
                     alkatrészre értelmes (a termék feladási idejét az
                     alkatrészei húzzák le). -->
                <div class="ce-field" *ngIf="!flagOn('is_custom') && !flagOn('for_sale')">
                    <label class="ce-check">
                        <input type="checkbox" [checked]="flagOn('dispatch_rule_exempt')"
                               (change)="toggleFlag('dispatch_rule_exempt')">
                        <span>Ne vonatkozzon rá a feladási szabály</span>
                    </label>
                    <div class="ce-limit-info__note">
                        Bekapcsolva ez az alkatrész nem befolyásolja a termékek feladási idejét —
                        a mindig raktáron lévő csomagolóanyagnál ez a helyes beállítás.
                    </div>
                </div>
                <div class="ce-custom-note" *ngIf="flagOn('is_custom')">Egyedi komponens — rendelésre gyártjuk, nincs minimum készletszint, és a raktár szabály sem írja felül.</div>
            </div>

            <!-- Műveletek -->
            <div class="ce-actions">
                <button type="button" class="stk-btn stk-btn--danger" *ngIf="componentId > 0" [disabled]="deleting" (click)="deleteComponent()">
                    {{ deleting ? 'Törlés…' : 'Törlés' }}
                </button>
                <div class="ce-actions__spacer"></div>
                <button type="button" class="stk-btn stk-btn--ghost" [disabled]="!componentId || saving" (click)="saveComponent(true)">Mentés másként</button>
                <button type="submit" class="stk-btn stk-btn--accent" [disabled]="saving">
                    {{ saving ? 'Mentés…' : 'Mentés' }}
                </button>
            </div>
        </div>

        <!-- Összetevő komponensek (BOM) -->
        <div class="ce-col ce-col--bom" *ngIf="componentForm.get('has_bom')?.value">
            <div class="ce-card">
                <div class="ce-card__kicker-row">
                    <div class="ce-card__kicker">Összetevő komponensek</div>
                    <span class="ce-card__kicker-note">1 egységhez</span>
                </div>

                <div class="ce-bom-empty" *ngIf="!bomArray.controls.length">Adj hozzá komponenseket, amikből ez összeáll.</div>

                <div class="ce-bom-list" formArrayName="bom">
                    <div class="ce-bom-row" *ngFor="let bomFormGroup of bomArray.controls; let i = index" [formGroup]="$any(bomFormGroup)">
                        <img class="ce-bom-row__img" *ngIf="bomFormGroup.get('component_child')?.value?.image_file"
                             [appFetchComponentImage]="bomFormGroup.get('component_child')?.value?.image_file" alt="">
                        <span class="ce-bom-row__img ce-bom-row__img--placeholder" *ngIf="!bomFormGroup.get('component_child')?.value?.image_file"></span>
                        <div class="ce-bom-row__selector">
                            <app-bgf-auto-selector instanceType="component" formControlName="component_child"></app-bgf-auto-selector>
                        </div>
                        <div class="ce-bom-row__qty">
                            <span>×</span>
                            <input type="number" min="1" formControlName="quantity" name="quantity">
                        </div>
                        <button type="button" class="ce-bom-row__remove" title="Eltávolítás" (click)="removeChildComponent(i)">
                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                        </button>
                    </div>
                </div>

                <button type="button" class="ce-bom-add" (click)="addNewBomComponent()">
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                    Komponens hozzáadása
                </button>
            </div>
        </div>

    </form>
</div>
